import { NavLink, NavLinkProps } from 'theme-ui';

export interface TabLinkProps extends NavLinkProps {}

const TabLink: React.FC<TabLinkProps> = (props) => <NavLink {...props} />;

TabLink.defaultProps = {
  variant: 'tab'
};

export default TabLink;
